import { QuoteSourceEnum } from '../../shared/generated';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getBrokerPlatformMap = function getBrokerPlatformMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    acturis: {
      label: $t('kit:brokers.acturis'),
      value: 'acturis'
    }
  };
};
export var getBrokerPlatformList = function getBrokerPlatformList() {
  return Object.values(getBrokerPlatformMap());
};
export var getBrokerQuotingThroughMap = function getBrokerQuotingThroughMap() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return {
    acturis: {
      label: $t('kit:brokers.acturis'),
      value: QuoteSourceEnum.ACTURIS
    },
    landingPage: {
      label: $t('kit:brokers.landing_page'),
      value: QuoteSourceEnum.JOVE_QUOTE
    },
    brokerPortal: {
      label: $t('kit:brokers.broker_portal'),
      value: QuoteSourceEnum.JOVE_CMS
    },
    validation: {
      label: 'Validation',
      value: 'jove_validation'
    }
  };
};
export var getBrokerQuotingThroughList = function getBrokerQuotingThroughList() {
  return Object.values(getBrokerQuotingThroughMap());
};
export var getBrokerQuickSearchSpecialFieldForJoveMap = function getBrokerQuickSearchSpecialFieldForJoveMap() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return {
    acturisReferred: {
      label: $t('kit:brokers.acturis_referred'),
      value: 'acturis_referred'
    },
    // quoteReferred: {
    //   label: $t('kit:quotes.quote_referred'),
    //   value: 'quote_referred',
    // },
    referral: {
      label: $t('kit:quotes.referral'),
      value: 'referral'
    },
    acturisPartiallyQuoted: {
      label: $t('kit:brokers.acturis_partially_quoted'),
      value: 'acturis_partially_quoted'
    },
    pendingPremiumOverwrite: {
      label: $t('kit:quotes.pending_premium_overwrite'),
      value: 'pending_premium_overwrite'
    }
  };
};
export var getBrokerQuickSearchSpecialFieldForJoveList = function getBrokerQuickSearchSpecialFieldForJoveList() {
  return Object.values(getBrokerQuickSearchSpecialFieldForJoveMap());
};
export var getBrokerQuickSearchSpecialFieldForBrokerMap = function getBrokerQuickSearchSpecialFieldForBrokerMap() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return {
    premiumUpdatedByJove: {
      label: $t('kit:quotes.premium_updated_by_jove'),
      value: 'premium_updated_by_jove'
    },
    referralApproved: {
      label: $t('kit:quotes.referral_approved'),
      value: 'referral_approved'
    },
    referralDeclined: {
      label: $t('kit:quotes.referral_declined'),
      value: 'referral_declined'
    },
    premiumOverwriteApproved: {
      label: $t('kit:quotes.premium_overwrite_approved'),
      value: 'premium_overwrite_approved'
    },
    premiumOverwriteDeclined: {
      label: $t('kit:quotes.premium_overwrite_declined'),
      value: 'premium_overwrite_declined'
    }
  };
};
export var getBrokerQuickSearchSpecialFieldForBrokerList = function getBrokerQuickSearchSpecialFieldForBrokerList() {
  return Object.values(getBrokerQuickSearchSpecialFieldForBrokerMap());
};